// Componente Layout - Layout principal de la aplicación
// Incluye Header y Footer que se mostrarán en todas las páginas

import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import './Layout.css'

/**
 * Componente Layout
 * Layout principal que envuelve el contenido de las páginas
 * Usa Outlet para renderizar las rutas hijas
 */
function Layout() {
  return (
    <div className="layout">
      {/* Header fijo en la parte superior */}
      <Header />
      
      {/* Contenido principal de la página - Outlet renderiza las rutas hijas */}
      <main className="layout-main">
        <Outlet />
      </main>
      
      {/* Footer al final */}
      <Footer />
    </div>
  )
}

export default Layout

